import LZString from 'lz-string';

const LZ_PREFIX = '__lz__v1';

const secureStorage = {
  setItem: (key, value) => {
    if (value === undefined) {
      localStorage.removeItem(key);
      return;
    }

    const json = JSON.stringify(value);
    if (json === undefined) {
      localStorage.removeItem(key);
      return;
    }

    try {
      localStorage.setItem(key, json);
    } catch (error) {
      try {
        const compressed = LZString.compressToUTF16(json);
        localStorage.setItem(
          key,
          JSON.stringify({ [LZ_PREFIX]: true, data: compressed })
        );
      } catch (compressionError) {
        // Re-throw original error (QuotaExceededError, etc.)
        throw error;
      }
    }
  },
  getItem: (key) => {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    try {
      const parsed = JSON.parse(stored);
      if (
        parsed &&
        typeof parsed === 'object' &&
        parsed[LZ_PREFIX] === true &&
        typeof parsed.data === 'string'
      ) {
        const decompressed = LZString.decompressFromUTF16(parsed.data);
        if (!decompressed) return null;
        return JSON.parse(decompressed);
      }
      return parsed;
    } catch (error) {
      console.error(`Erreur lors du parsing de la clé "${key}" :`, error);
      return null;
    }
  },
  removeItem: (key) => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },

  length: () => {
    return localStorage.length;
  },

  key: (index) => {
    return localStorage.key(index);
  },
};

export default secureStorage;